export const GET_PLANS = 'GET_PLANS';
export const SELECT_PLAN = 'SELECT_PLAN';
export const SUBSCRIBED_PLAN = 'SUBSCRIBED_PLAN';
export const UNSUBSCRIBED_PLAN = 'UNSUBSCRIBED_PLAN';
